  import * as ActionTypes from "../Types/ActionTypes";

  export const BillStats = (
    state = {
      isLoading: false,
      FinalBillsState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.FINAL_BILLS_ANALYTICS_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.FINAL_BILLS_ANALYTICS:
        return {
          ...state,
          isLoading: false,
          FinalBillsState: action.payload,
        };

      case ActionTypes.FINAL_BILLS_ANALYTICS_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
